import { ICONS } from '../../../assets/icons/index';

export const STATUS = [
  {
    id: 1,
    icon: ICONS?.runningCampaign,
    label: 'Running',
    key: 'running',
    status: 'RUNNING',
    isSelected: false,
  },
  {
    id: 2,
    icon: ICONS?.PausedBlack,
    label: 'Paused',
    key: 'paused',
    status: 'PAUSED',
    isSelected: false,
  },
  {
    id: 3,
    icon: ICONS?.completed,
    label: 'Completed',
    key: 'completed',
    status: 'COMPLETED',
    isSelected: false,
  },
  {
    id: 4,
    icon: ICONS?.draft,
    label: 'Draft',
    key: 'draft',
    status: 'DRAFT',
    isSelected: false,
  },
];

export const SORT = [
  {
    id: 1,
    heading: 'Sort By',
    options: [
      {
        id: 1,
        icon: ICONS?.newestFirst,
        label: 'Newest First',
        key: 'newest',
        status: 'desc',
        field: 'created_at',
        isSelected: true,
      },
      {
        id: 2,
        icon: ICONS?.oldestFirst,
        label: 'Oldest First',
        key: 'oldest',
        status: 'asc',
        field: 'created_at',
        isSelected: false,
      },
      {
        id: 3,
        icon: ICONS?.ascending,
        label: 'Name (A-Z)',
        key: 'name_asc',
        status: 'asc',
        field: 'name',
        isSelected: false,
      },
      {
        id: 4,
        icon: ICONS?.descending,
        label: 'Name (Z-A)',
        key: 'name_desc',
        status: 'desc',
        field: 'name',
        isSelected: false,
      },
    ],
  },
];

// SEQUENCE_STYLES - exact same pattern as campaigns/constants/Execution.js
// Numeric keys match the sequence status values from the API
export const SEQUENCE_STYLES = {
  '-10': {
    icon: '',
    bg: '',
    color: '',
    text: 'Deleted',
  },
  'NEW': {
    icon: ICONS?.draft,
    bg: '#EDEFF1',
    color: '#566F8F',
    text: 'Draft',
  },
  'DRAFT': {
    icon: ICONS?.draft,
    bg: '#EDEFF1',
    color: '#566F8F',
    text: 'Draft',
  },
  'SCHEDULED': {
    icon: ICONS?.BroadCastActive,
    bg: '#FFFBEB',
    color: '#F6A723',
    text: 'Scheduled',
  },
  'ACTIVE': {
    icon: ICONS?.CampaignRunningIcon,
    bg: '#F0FDF4',
    color: '#25C277',
    text: 'Running',
  },
  'PAUSED': {
    icon: ICONS?.PausedOrange,
    bg: '#FFF4EB',
    color: '#FF7700',
    text: 'Paused',
  },
  'RUNNING': {
    icon: ICONS?.CampaignRunningIcon,
    bg: '#F0FDF4',
    color: '#25C277',
    text: 'Running',
  },
  'COMPLETED': {
    icon: ICONS?.CampaignCompleteIcon,
    bg: '#EFF5FF',
    color: '#4C90F5',
    text: 'Completed',
  },
};
